
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth } from '../../constants/api';
import {
  ALL_CATEGORY_FETCH,
  EXTERNAL_CATEGORY_FETCH,

  ALL_SUBCATEGORY_FETCH,
  HELP_FETCH,
  HELP_DETAIL_FETCH,
  POLICY_LIST_FETCH,
  SEARCH_HELP_LIST_FETCH
} from '../actions';

import {
  allCategoryFetchSuccess,
  allCategoryFetchFail,
  externalCategoryFetchSuccess,
  externalCategoryFetchFail,
  allSubcategoryFetchSuccess,
  allSubcategoryFetchFail,
  HelpDataFetchSuccess,
  HelpDataFetchFail,
  HelpDetailDataFetchSuccess,
  HelpDetailDataFetchFail,
  policyListFetchSuccess,
  policyListFetchFail,
  searchHelpListFetchSuccess,
  searchHelpListFetchFail
} from './actions';

import { sortOrder } from '../../helpers/Utils';

const allCategoryFetchAsync = async (req) =>
  await API.post('/setting/category',
    {
      "categoryId": '',
      "platform": "web"
    },
    {
      "headers": auth
    })
    .then(payments => payments)
    .catch(error => error);

function* allCategoryFetch({ payload }) {
  const { allCategory } = payload
  // console.log('payload -> ', payload)
  try {
    const allCategoryFetch = yield call(allCategoryFetchAsync, allCategory);

    if (allCategoryFetch.data.StatusCode === "0000") {
      const data = allCategoryFetch.data.ResultValues
      // console.log('data -> 'allCategory, data)
      yield put(allCategoryFetchSuccess(data));
    } else {
      yield put(allCategoryFetchFail(allCategoryFetch.data.Message));
    }
  } catch (error) {
    yield put(allCategoryFetchFail(error));
  }
}

const allSubcategoryFetchAsync = async (req) =>
  await API.post('/setting/category',
    {
      "categoryId": '',
      "platform": "web"
    },
    {
      "headers": auth
    })
    .then(payments => payments)
    .catch(error => error);

function* allSubcategoryFetch({ payload }) {
  const { allSubcategory } = payload
  // console.log('payload -> ', payload)
  try {
    const allSubcategoryFetch = yield call(allSubcategoryFetchAsync, allSubcategory);

    if (allSubcategoryFetch.data.StatusCode === "0000") {
      const data = allSubcategoryFetch.data.ResultValues
      // console.log('data -> 'allCategory, data)
      yield put(allSubcategoryFetchSuccess(data));
    } else {
      yield put(allSubcategoryFetchFail(allSubcategoryFetch.data.Message));
    }
  } catch (error) {
    yield put(allSubcategoryFetchFail(error));
  }
}

/* help */
const HelpDataFetchAsync = async (req) =>
  await API.post('/setting/help',
    {
      "categoryId": req.categoryId,
      "categoryName": ""
    },
    {
      "headers": auth
    })
    .then(payments => payments)
    .catch(error => error);

function* HelpDataFetch({ payload }) {
  const { HelpData } = payload
  // console.log('payload -> ', payload)
  try {
    const HelpDataFetch = yield call(HelpDataFetchAsync, HelpData);

    if (HelpDataFetch.data.StatusCode === "0000") {
      const data = HelpDataFetch.data.ResultValues
      yield put(HelpDataFetchSuccess(data));
    } else {
      yield put(HelpDataFetchFail(HelpDataFetch.data.Message));
    }
  } catch (error) {
    yield put(HelpDataFetchFail(error));
  }
}

/* help detail */
const HelpDetailDataFetchAsync = async (req) =>
  await API.post('/setting/help/detail',
    {
      "helpId": req.helpId
    },
    {
      "headers": auth
    })
    .then(payments => payments)
    .catch(error => error);

function* HelpDetailDataFetch({ payload }) {
  const { HelpDetailData } = payload
  // console.log('payload -> ', payload)
  try {
    const HelpDetailDataFetch = yield call(HelpDetailDataFetchAsync, HelpDetailData);

    if (HelpDetailDataFetch.data.StatusCode === "0000") {
      const data = HelpDetailDataFetch.data.ResultValues
      yield put(HelpDetailDataFetchSuccess(data));
    } else {
      yield put(HelpDetailDataFetchFail(HelpDetailDataFetch.data.Message));
    }
  } catch (error) {
    yield put(HelpDetailDataFetchFail(error));
  }
}

/* policy */
const policyListFetchAsync = async (req) =>
  await API.post('/setting/org',
    {
      "helpId": ''
    },
    {
      "headers": auth
    })
    .then(payments => payments)
    .catch(error => error);

function* policyListFetch({ payload }) {
  const { policyList } = payload
  // console.log('payload -> ', payload)
  try {
    const policyListFetch = yield call(policyListFetchAsync, policyList);

    if (policyListFetch.data.StatusCode === "0000") {
      const data = policyListFetch.data.ResultValues

      if (data.length > 0) {

        data[0].menu.map(async (value, key) => {

          if (value.menu_key == 'home') {
            await localStorage.setItem('menu_home', value.menu_web == 1)
          } else if (value.menu_key == 'live') {
            await localStorage.setItem('menu_live', value.menu_web == 1)
          } else if (value.menu_key == 'popular') {
            await localStorage.setItem('menu_popular', value.menu_web == 1)
          } else if (value.menu_key == 'interesting') {
            await localStorage.setItem('menu_interesting', value.menu_web == 1)
          } else if (value.menu_key == 'all_program') {
            await localStorage.setItem('menu_all_program', value.menu_web == 1)
          } else if (value.menu_key == 'favorites') {
            await localStorage.setItem('menu_favorites', value.menu_web == 1)
          } else if (value.menu_key == 'radio') {
            await localStorage.setItem('menu_radio', value.menu_web == 1)
          }
        })


      }


      yield put(policyListFetchSuccess(data));
    } else {
      yield put(policyListFetchFail(policyListFetch.data.Message));
    }
  } catch (error) {
    yield put(policyListFetchFail(error));
  }
}

/* search help */
const searchHelpListFetchAsync = async (req) =>
  await API.post('/setting/searchhelp',
    {
      "search": req.search
    },
    {
      "headers": auth
    })
    .then(payments => payments)
    .catch(error => error);

function* searchHelpListFetch({ payload }) {
  const { searchHelpList } = payload
  // console.log('payload -> ', payload)
  try {
    const searchHelpListFetch = yield call(searchHelpListFetchAsync, searchHelpList);

    if (searchHelpListFetch.data.StatusCode === "0000") {
      const data = searchHelpListFetch.data.ResultValues
      yield put(searchHelpListFetchSuccess(data));
    } else {
      yield put(searchHelpListFetchFail(searchHelpListFetch.data.Message));
    }
  } catch (error) {
    yield put(searchHelpListFetchFail(error));
  }
}


const externalCategoryFetchAsync = async (req) =>
  await API.post('/setting/externalcategory',
    {
      "categoryId": ''
    },
    {
      "headers": auth
    })
    .then(payments => payments)
    .catch(error => error);

function* externalCategoryFetch({ payload }) {
  const { externalCategory } = payload
  // console.log('payload -> ', payload)
  try {
    const externalCategoryFetch = yield call(externalCategoryFetchAsync, externalCategory);

    if (externalCategoryFetch.data.StatusCode === "0000") {
      const data = externalCategoryFetch.data.ResultValues
      // console.log('data -> 'externalCategory, data)
      yield put(externalCategoryFetchSuccess(data));
    } else {
      yield put(externalCategoryFetchFail(externalCategoryFetch.data.Message));
    }
  } catch (error) {
    yield put(externalCategoryFetchFail(error));
  }
}

export function* watchSettingFetch() {
  yield takeEvery(ALL_CATEGORY_FETCH, allCategoryFetch);
  yield takeEvery(EXTERNAL_CATEGORY_FETCH, externalCategoryFetch);

  yield takeEvery(ALL_SUBCATEGORY_FETCH, allSubcategoryFetch);
  yield takeEvery(HELP_FETCH, HelpDataFetch);
  yield takeEvery(HELP_DETAIL_FETCH, HelpDetailDataFetch);
  yield takeEvery(POLICY_LIST_FETCH, policyListFetch);
  yield takeEvery(SEARCH_HELP_LIST_FETCH, searchHelpListFetch);
}

export default function* rootSaga() {
  yield all([
    fork(watchSettingFetch),
  ]);
}
